import { Component, OnInit, Input, SimpleChanges, NgZone, ChangeDetectorRef, OnChanges, OnDestroy } from '@angular/core';
import { ProductService } from 'src/app/services/product.service'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api'; import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressBarModule } from 'primeng/progressbar';
import { HttpClientModule } from '@angular/common/http';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { CartFacadeService } from 'src/app/services/cart-facade.service';
import { PlatformService } from 'src/app/services/platform.service';
import { HotspotProductState } from 'src/app/models/hotspot.model';
import { Subscription } from 'rxjs';
import { DialogAguardeComponent } from '../dialog-aguarde/dialog-aguarde.component';
import { PMetaStoreService } from 'src/app/services/p-meta-store.service';
@Component({
  selector: 'app-show-products',
  standalone: true,
  templateUrl: './show-products.component.html',
  styleUrls: ['./show-products.component.scss'],
  imports: [
    CommonModule, HttpClientModule, DialogAguardeComponent, ToastModule, FormsModule, InputNumberModule, ButtonModule, DialogModule, TagModule, SkeletonModule, ProgressBarModule
  ]
})
export class ShowProductsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sku: number = 0;
  @Input() trackPixelEvents: boolean = true;
  outOfStock: boolean = false;
  isAddingToCart = false;
  product: any; // Produto principal
  productImages: string[] = [];
  mainImage: string = '';
  childProducts: any[] = [];
  attributes: { name: string; values: string[] }[] = [];
  selectedAttributes: { [key: string]: string } = {};
  selectedChildProduct: any = null;
  quantity: number = 1;
  inventoryQuantity: number = 0; // Estoque do produto filho selecionado
  maxQuantity: number = 0; // Quantidade máxima permitida
  platform?: string;
  private cartUpdatedSub?: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private errorHandler: ErrorHandlerService,
    private messageService: MessageService,
    private productService: ProductService,
    private platformService: PlatformService,
    private cartService: ShoppingCartService,
    private cartFacade: CartFacadeService,
    private ngZone: NgZone,
    private pMetaStore: PMetaStoreService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sku']?.currentValue && changes['sku'].currentValue !== changes['sku'].previousValue) {
      this.resetForNewSku();          // ✅ AQUI
      this.loadProductDetails(this.sku); // ✅ SEU método atual, com productId
    }
  }

  private resetForNewSku(): void {
    // 🔥 flags que estavam “vazando” pro próximo produto
    this.isAddingToCart = false;
    this.outOfStock = false;

    // reseta quantidade/estoque
    this.quantity = 1;
    this.inventoryQuantity = 0;

    // importante: maxQuantity 0 pode ser interpretado como “sem estoque”
    // então deixe algo neutro até calcular de verdade
    this.maxQuantity = 999999;

    // reseta seleção
    this.selectedChildProduct = null;
    this.selectedAttributes = {};

    // opcional: limpar skeleton/aguarde de forma consistente
    this.isLoadingSkeleton = true;

    this.ngZone.run(() => this.cdr.detectChanges());
  }



  ngOnInit(): void {

    // 🔥 Obtém a plataforma armazenada no `localStorage`
    this.platform = this.platformService.identifyPlatform();
    if (!this.platform) {
      console.error("Nenhuma plataforma definida para o carrinho.");
      return;
    }

    // ✅ Verifica se o SKU já está presente e carrega o produto
    if (this.sku) {
      this.loadProductDetails(this.sku);
    } else {
      this.displayAguarde = false;
    }

    this.cartUpdatedSub = this.cartService.cartUpdated$.subscribe(() => {
      this.ngZone.run(() => this.refreshAvailability());
    });
  }


  isLoadingSkeleton = true;
  loadProductDetails(productId: number): void {
    let productIdStr = productId.toString();

    if (productIdStr) {
      //this.displayAguarde = true;
      this.isLoadingSkeleton = true;

      // Resetar os valores antes de carregar o novo produto
      this.product = null;
      this.productImages = [];
      this.mainImage = '';
      this.childProducts = [];
      this.attributes = [];
      this.selectedAttributes = {};
      this.selectedChildProduct = null;
      this.quantity = 1;
      this.inventoryQuantity = 0;
      //////////////////////
      this.maxQuantity = 999999; // neutro até calcular de verdade
      this.outOfStock = false;   // garante que o botão volta
      this.isAddingToCart = false;
      //////////////////////

      this.productService.getDetailProduct(productIdStr).subscribe({
        next: (response) => {
          console.log('detalhes do produto')
          console.log(response)

          this.product = response.product;
          this.ensureProductCategories(this.product);
          this.productImages = this.product.images;
          this.mainImage = this.productImages[0];
          this.emitProductViewEvent(this.product);


          this.productService.getChildremProducts(productIdStr).subscribe({
            next: (childResponse) => {
              this.childProducts = childResponse.children;

              if (this.childProducts.length > 0) {
                this.selectedChildProduct = this.childProducts[0];
                this.updateProductDetails(this.selectedChildProduct);

                this.selectedChildProduct.selectedOptions.forEach((opt: any) => {
                  this.selectedAttributes[opt.name] = opt.value;
                });

                this.productService.getChildremProductsAttributes(productIdStr).subscribe({
                  next: (attributesResponse) => {
                    this.processAttributes(attributesResponse.attributes);
                    this.displayAguarde = false;
                    this.isLoadingSkeleton = false;
                    this.cdr.detectChanges();
                  },
                  error: (error) => {
                    console.error('❌ Erro ao carregar atributos dos produtos filhos:', error);
                    this.displayAguarde = false;
                    this.errorHandler.handle(error, 'Não foi possível carregar os atributos dos produtos filhos.');
                  }
                });
              } else {
                this.selectedChildProduct = null;
                this.displayAguarde = false;
                this.isLoadingSkeleton = false;
                this.inventoryQuantity = this.product?.inventory_quantity || 0;
                this.refreshAvailability(this.product, true);
              }
            },
            error: (childError) => {
              this.displayAguarde = false;
              this.errorHandler.handle(childError, 'Não foi possível carregar os produtos filhos deste item.');
            }
          });
        },
        error: (error) => {
          this.displayAguarde = false;
          this.errorHandler.handle(error, 'Não foi possível carregar os detalhes do produto. Tente novamente.');
        }
      });
    }
  }



  processAttributes(attributesResponse: any[]): void {
    // Nada retornado → sem atributos
    if (!attributesResponse || !attributesResponse.length) {
      this.attributes = [];
      return;
    }

    // 👇 Pega o primeiro nó (já serve pro nosso caso Shopify)
    const firstNode = attributesResponse[0]?.node ?? attributesResponse[0];

    const firstOpts = firstNode?.selectedOptions ?? [];

    // 🔍 Caso típico de "produto sem variação real":
    //  - só 1 registro em attributesResponse
    //  - só 1 selectedOption
    //  - nome da option é "Title"
    if (
      attributesResponse.length === 1 &&
      firstOpts.length === 1 &&
      firstOpts[0]?.name === 'Title'
    ) {
      // 👉 Não mostramos atributos na UI
      this.attributes = [];
      return;
    }

    // ✅ Caso contrário, monta normalmente
    const attributeMap: { [key: string]: Set<string> } = {};

    attributesResponse.forEach((item) => {
      const node = item?.node || item;
      const selectedOptions = node?.selectedOptions || [];

      selectedOptions.forEach((option: { name: string; value: string }) => {
        if (!attributeMap[option.name]) {
          attributeMap[option.name] = new Set();
        }
        attributeMap[option.name].add(option.value);
      });
    });

    this.attributes = Object.keys(attributeMap).map((key) => ({
      name: key,
      values: Array.from(attributeMap[key]),
    }));
  }


  selectAttribute(attributeName: string, value: string): void {
    this.selectedAttributes[attributeName] = value;
    const selectedChild = this.childProducts.find((child) =>
      Object.keys(this.selectedAttributes).every(
        (key) =>
          child.selectedOptions?.some(
            (opt: any) => opt.name === key && opt.value === this.selectedAttributes[key]
          )
      )
    );
    if (selectedChild) {
      this.selectedChildProduct = selectedChild;
      this.updateProductDetails(selectedChild);
    } else {
      this.selectedChildProduct = null;
      this.resetProductDetails();
    }
  }
  unlimitedStock = 9999;
  handleQuantityChange(): void {
    console.log('chamou handleQuantityChange')
    const product = this.selectedChildProduct || this.product;
    if (!product) {
      return;
    }

    this.refreshAvailability(product);
  }

  private refreshAvailability(productOverride?: any, detectChanges: boolean = false): void {
    const target = productOverride || this.selectedChildProduct || this.product;
    if (!target) {
      return;
    }

    if (target.tracked) {
      const available = this.calculateAvailableQuantity(target);
      this.maxQuantity = available;
      this.outOfStock = available === 0;

      if (available === 0) {
        this.quantity = 0;
      } else {
        if (this.quantity === 0) {
          this.quantity = 1;
        }
        if (this.quantity > available) {
          this.quantity = available;
        }
      }
    } else {
      this.maxQuantity = Infinity;
      this.outOfStock = false;
      if (this.quantity < 1) {
        this.quantity = 1;
      }
    }

    if (detectChanges) {
      this.cdr.detectChanges();
    }
  }

  updateProductDetails(child: any): void {
    if (!child) return;

    console.log('selectedChildProduct', child);
    console.log('variant guess', {
      variant_id: child?.variant_id,
      id: child?.id,
      selected_or_first_available_variant: child?.selected_or_first_available_variant?.id,
      selected_variant: child?.selected_variant?.id,
      inventory_quantity: child?.inventory_quantity,
      tracked: child?.tracked,
      selectedOptions: child?.selectedOptions,
      title: child?.title,
    });

    this.selectedChildProduct = child;
    this.product.price = child.price;
    this.product.compare_at_price = child.compare_at_price || null;

    // Atualiza a imagem principal se a variante tiver uma imagem própria
    if (child.thumbnail) {
      this.mainImage = child.thumbnail;
    }

    this.inventoryQuantity = child.tracked ? (child.inventory_quantity || 0) : this.unlimitedStock;

    this.refreshAvailability(child, true);
  }
  getProductTitle(): string {
    const baseTitle = this.product?.title ?? "Produto sem nome";

    if (this.selectedChildProduct) {
      // 🔥 Constrói o título concatenando todas as opções da variante
      const variantTitle = this.selectedChildProduct.selectedOptions
        .map((opt: any) => opt.value) // Apenas os valores das opções
        .join(" / "); // Junta as opções com "/"

      return variantTitle ? `${baseTitle} - ${variantTitle}` : baseTitle;
    }

    return baseTitle;
  }

  changeMainImage(image: string): void {
    this.mainImage = image;
  }

  resetProductDetails(): void {
    this.product.title = this.product.title;
    this.product.price = this.product.price;
    this.product.compare_at_price = this.product.compare_at_price || null;
    this.inventoryQuantity = 0;
    this.maxQuantity = 0;
  }
  cartProductIds: string[] = [];

  async addToCart() {
    if (this.isAddingToCart) {
      return;
    }

    const product = this.selectedChildProduct || this.product;
    this.quantity = Math.max(1, Number(this.quantity) || 1);
    const categories = this.getCategoryNames(this.product);

    if (product.tracked) {
      const estoqueTotal = this.inventoryQuantity || product.inventory_quantity || 0;
      const jaNoCarrinho = this.getCurrentQuantityInCart(product); // 🔎 pega quantidade já adicionada
      const disponivel = estoqueTotal - jaNoCarrinho;

      if (disponivel <= 0) {
        // Já atingiu o limite, não deixa adicionar mais
        this.messageService.add({
          severity: 'warn',
          summary: 'Estoque máximo atingido',
          detail: 'Você já adicionou a quantidade máxima disponível deste produto.'
        });
        // Garante que o input também mostra 0 (ou 1, se preferir bloquear botão)
        this.quantity = 0;
        this.cdr.detectChanges();
        return;
      }

      console.log('antes do if')
      console.log(this.quantity)
      // Se o usuário pediu mais do que ainda tem disponível, ajusta a quantity
      if (this.quantity > disponivel) {
        this.quantity = disponivel;
        this.cdr.detectChanges();
      }
      console.log(this.quantity)
    }

    // 🔥 Gera o nome completo: Nome do Produto + Variante
    const fullProductName = this.selectedChildProduct
      ? `${this.product.title} - ${this.selectedChildProduct.title}`
      : this.product.title;


    const payload = {
      ...this.product,
      selectedVariant: this.selectedChildProduct || undefined,
      thumbnail: this.mainImage,
      mainImage: this.mainImage,
      categories,
      category: categories.length ? categories[0] : ''
    };
    console.log(this.quantity)

    /////////////////////
    console.log('[UI] selectedChildProduct', this.selectedChildProduct);
    console.log('[UI] variant guess', {
      variant_id: this.selectedChildProduct?.variant_id,
      id: this.selectedChildProduct?.id,
      option1: this.selectedChildProduct?.option1,
      option2: this.selectedChildProduct?.option2,
      option3: this.selectedChildProduct?.option3,
      options: this.selectedChildProduct?.options,
      selectedOptions: this.selectedChildProduct?.selectedOptions,
    });

    /////////////////////


    const cartItem = this.cartFacade.toCartItemFromProduct(payload, this.quantity);

    console.log('[CART ITEM]', {
      product_id: cartItem.product_id,
      variant_id: cartItem.variant_id,
      id: cartItem.id,
      name: cartItem.name,
    });



    console.log('addToCart em showProdutcs')
    console.log(cartItem)

    this.isAddingToCart = true;
    this.cdr.detectChanges();
    try {
      this.cartService.refreshCartState();
      const result = await this.cartFacade.addMany([cartItem], (this.platform as any) || 'local');
      this.cartService.refreshCartState();

      const totalItems = result?.total ?? 0;
      this.messageService.add({
        severity: 'success',
        summary: 'Itens adicionados',
        detail: `${result?.itemsAdded ?? 0} ${result?.itemsAdded === 1 ? 'item' : 'itens'}`
      });
      const addToCartDetail = this.buildAddToCartDetail(cartItem, payload);
      console.log('fora buildAddToCartDetail');
      (addToCartDetail as any).total = totalItems;
      window.dispatchEvent(new CustomEvent('customEvents', { detail: addToCartDetail }));
      if (this.trackPixelEvents) {
        this.pMetaStore.sendAddToCartPixelEvent(addToCartDetail, this.getCurrentAssetUid());
      }
      this.refreshAvailability(product, true);
    } catch (error: any) {
      console.log('status', error?.status);
      console.log('message', error?.message);
      console.log('error typeof', typeof error?.error);
      console.log('error snippet', String(error?.error ?? '').slice(0, 120));

      const errorMessage =
        error?.message ||
        error?.detail ||
        'Ocorreu um erro ao adicionar o produto.';

      this.messageService.add({
        severity: 'error',
        summary: 'Não foi possível adicionar',
        detail: errorMessage
      });

      this.errorHandler.handle(error, errorMessage);

      // ✅ se você quiser propagar pro caller, joga throw AQUI no fim
      // throw error;
    } finally {
      this.ngZone.run(() => {
        this.isAddingToCart = false;
        this.cdr.detectChanges();
      });
    }
  }

  async addHotspotItems(items: HotspotProductState[]): Promise<void> {
    console.log('em addHotspotItems 1')
    if (!items?.length) {
      return;
    }
    console.log('em addHotspotItems 2')
    const cartItems = items.map((p) => {
      const qty = Number((p as any).quantity) || 1;
      return this.cartFacade.toCartItemFromProduct(p, qty);
    });
    console.log('em addHotspotItems cartItems')
    console.log(cartItems)
    try {
      const result = await this.cartFacade.addMany(cartItems, (this.platform as any) || 'local');
      this.cartService.refreshCartState();
      this.messageService.add({
        severity: 'success',
        summary: 'Itens adicionados',
        detail: `${result?.itemsAdded ?? cartItems.length} ${(result?.itemsAdded ?? cartItems.length) === 1 ? 'item' : 'itens'}`
      });
      console.log('em addHotspotItems 3')
      const detailItems = cartItems.map(i => this.buildAddToCartDetail(i));
      window.dispatchEvent(new CustomEvent('customEvents', {
        detail: cartItems.length > 1
          ? { event: 'add_to_cart_bundle', items: detailItems, total: result?.total ?? 0 }
          : { ...detailItems[0], total: result?.total ?? 0 }
      }));
      if (this.trackPixelEvents) {
        detailItems.forEach(item => this.pMetaStore.sendAddToCartPixelEvent(item, this.getCurrentAssetUid()));
      }
    } catch (error: any) {
      const detail =
        error?.message ||
        error?.detail ||
        'Falha ao adicionar os itens ao carrinho.';
      this.messageService.add({
        severity: 'error',
        summary: 'Não foi possível adicionar',
        detail
      });
    }
  }

  private calculateAvailableQuantity(product: any): number {
    if (!product?.tracked) {
      return Infinity;
    }
    const estoqueTotal = Number(product.inventory_quantity ?? this.inventoryQuantity ?? 0);
    const jaNoCarrinho = this.getCurrentQuantityInCart(product);
    return Math.max(0, estoqueTotal - jaNoCarrinho);
  }

  private extractShopifyProductId(graphQLId: string): string {
    const match = graphQLId.match(/(\d+)$/); // 🔥 Extrai apenas os números finais do ID
    return match ? match[1] : graphQLId; // Se encontrar, retorna apenas o número
  }
  displayAguarde: boolean = true;

  private getCurrentAssetUid(): string | undefined {
    return localStorage.getItem('ss_current_asset_uid') ?? undefined;
  }

  ngOnDestroy(): void {
    this.cartUpdatedSub?.unsubscribe();
  }

  private getCartItemsFromStorage(): any[] {
    if (typeof window === 'undefined') return [];

    try {
      const raw = localStorage.getItem('ss_shopping_cart');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('Erro ao ler ss_shopping_cart', e);
      return [];
    }
  }

  private getCurrentQuantityInCart(product: any): number {
    const items = this.getCartItemsFromStorage();
    if (!items.length) return 0;

    // 🔥 prioridade: variant_id do produto selecionado (variante)
    const rawVariant =
      product?.variant_id ??
      product?.selected_or_first_available_variant?.id ??
      product?.selected_variant?.id ??
      product?.id;

    const variantKey = this.normalizeVariantKey(rawVariant);

    // se não conseguiu identificar a variante, não bloqueia por estoque (evita falso positivo)
    if (!variantKey) return 0;

    const existing = items.find((it: any) => {
      const storedVariantKey = this.normalizeVariantKey(
        it?.variant_id ?? it?.id
      );
      return storedVariantKey === variantKey;
    });

    return existing ? Number(existing.quantity || 0) : 0;
  }


  private normalizeVariantKey(raw: any): string {
    if (raw == null) return '';
    const str = String(raw);
    const match = str.match(/(\d+)$/);
    return match ? match[1] : str;
  }

  private emitProductViewEvent(product: any): void {
    if (typeof window === 'undefined' || !product || !this.trackPixelEvents) {
      return;
    }
    const categories = this.getCategoryNames(product);
    const enriched = {
      ...product,
      category: this.getPrimaryCategoryValue(categories),
      categories,
    };
    this.pMetaStore.sendProductViewEvent(enriched, this.getCurrentAssetUid() ?? null);
  }

  private buildAddToCartDetail(item: any, sourceProduct?: any) {
    const categories = this.getCategoryNames(sourceProduct ?? item);
    const variant =
      item?.variant ??
      sourceProduct?.variant ??
      sourceProduct?.selected_variant?.title ??
      sourceProduct?.selected_or_first_available_variant?.title ??
      '';
    return {
      event: 'ss_add_to_cart',
      sku: item.id,
      title: item.name,
      ...(variant ? { variant } : {}),
      category: this.getPrimaryCategoryValue(categories),
      categories,
      qty: item.quantity ?? 1,
      price: Number(item.price ?? sourceProduct?.price ?? 0)
    };
  }

  private ensureProductCategories(product: any): void {
    if (!product) {
      return;
    }
    const categories = this.getCategoryNames(product);
    product.categories = categories;
    if (!product.category && categories.length === 1) {
      product.category = categories[0];
    }
  }

  private getCategoryNames(source: any): string[] {
    if (!source) {
      return [];
    }

    const raw = Array.isArray(source.categories)
      ? source.categories
      : source.categories
        ? [source.categories]
        : source.category
          ? [source.category]
          : [];

    return raw
      .map((entry: any) => {
        if (!entry) return null;
        if (typeof entry === 'string') return entry.trim();
        if (typeof entry === 'object') {
          const name = entry.title ?? entry.name;
          return name ? String(name).trim() : null;
        }
        return null;
      })
      .filter((value: any): value is string => !!value && value.length > 0);
  }

  private getPrimaryCategoryValue(categories: string[]): string | string[] {
    if (!categories.length) {
      return '';
    }

    return categories.length === 1 ? categories[0] : categories;
  }

}
